export default __webpack_public_path__ + "static/media/slack-mark-web.b953afa6.png";